import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageBar, MessageBarType, PrimaryButton, DefaultButton } from '@fluentui/react';
export const ConfirmationDialog = ({ isVisible, onSendAgain, onCancel }) => {
    if (!isVisible)
        return null;
    return (_jsx("div", { style: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        }, children: _jsxs("div", { style: {
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '0px',
                maxWidth: '400px',
                width: '80%'
            }, children: [_jsx("h3", { style: { margin: '0 0 16px 0' }, children: "This email has already been sent for ingestion" }), _jsx("p", { style: { margin: '0 0 20px 0' }, children: "Are you sure you want to send this email again?" }), _jsxs("div", { style: { display: 'flex', gap: '12px', justifyContent: 'flex-end' }, children: [_jsx(DefaultButton, { text: "Cancel", onClick: onCancel }), _jsx(PrimaryButton, { text: "Send Again", onClick: onSendAgain })] })] }) }));
};
export const RetryButton = ({ isVisible, onRetry, reason, hasValidData = true }) => {
    if (!isVisible)
        return null;
    const getButtonText = () => {
        if (reason === 'DRAFT_EMAIL_NO_ITEM_ID') {
            return "Email forwarding not available for draft emails. Please save or send the email first.";
        }
        if (!hasValidData) {
            return "Retry not available - missing email data";
        }
        return "Retry Send to Shared Mailbox";
    };
    const isDisabled = reason === 'DRAFT_EMAIL_NO_ITEM_ID' || !hasValidData;
    return (_jsxs("div", { children: [_jsx(MessageBar, { messageBarType: MessageBarType.warning, isMultiline: true, styles: {
                    root: {
                        backgroundColor: "#FFF3CD",
                        border: "1px solid #FFEAA7",
                        color: "#856404",
                        marginBottom: 16,
                    },
                }, children: reason === 'DRAFT_EMAIL_NO_ITEM_ID'
                    ? "Email forwarding requires the email to be saved or sent first. The placement was successful, but forwarding to the shared mailbox is not available for draft emails."
                    : !hasValidData
                        ? "Email forwarding failed, but placement was successful. Retry is not available because the email data is not accessible."
                        : "Email forwarding failed, but placement was successful. You can retry forwarding to the shared mailbox." }), _jsx(PrimaryButton, { text: getButtonText(), onClick: onRetry, disabled: isDisabled, styles: {
                    root: {
                        marginTop: 16,
                        backgroundColor: isDisabled ? "#C8C6C4" : "#0F1E32",
                    },
                    rootHovered: {
                        backgroundColor: isDisabled ? "#C8C6C4" : "#0F1E32"
                    },
                    rootPressed: {
                        backgroundColor: isDisabled ? "#C8C6C4" : "#0F1E32"
                    },
                } })] }));
};
export const SuccessMessage = ({ isVisible, onSuccess }) => {
    if (!isVisible)
        return null;
    return (_jsxs("div", { children: [_jsx("header", { style: {
                    display: "flex",
                    alignItems: "center",
                    padding: "0px 0px",
                    backgroundColor: "transparent",
                }, children: _jsx("h3", { style: { margin: 0, padding: "20px 4px", display: "none" }, children: "Underwriting Workbench" }) }), _jsx(MessageBar, { messageBarType: MessageBarType.success, isMultiline: true, styles: {
                    root: {
                        backgroundColor: "#E6F4EA",
                        border: "1px solid #A6D8A8",
                        color: "#0F5132",
                        fontWeight: "normal",
                        marginTop: 20,
                        height: 200,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "left",
                    },
                    icon: {
                        color: "#198754",
                        fontSize: 28,
                        height: 28,
                        width: 28,
                        alignSelf: "center",
                    },
                }, children: _jsxs("div", { children: [_jsx("strong", { children: "Action Completed" }), _jsx("div", { children: "Your action was completed successfully." })] }) })] }));
};
export const ErrorMessage = ({ isVisible, message, onSubmit }) => {
    if (!isVisible)
        return null;
    return (_jsxs("div", { children: [_jsxs("div", { children: [_jsx("header", { style: {
                            display: "flex",
                            alignItems: "center",
                            padding: "0px 0px",
                            backgroundColor: "transparent",
                        }, children: _jsx("h3", { style: { margin: 0, padding: "20px 4px", display: "none" }, children: "Underwriting Workbench" }) }), _jsx(MessageBar, { messageBarType: MessageBarType.error, isMultiline: true, styles: {
                            root: {
                                backgroundColor: "#FBE9E7",
                                border: "1px solid #F4F4F4",
                                color: "#0F5132",
                                fontWeight: "normal",
                                marginTop: 20,
                                height: 200,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "left",
                            },
                            icon: {
                                color: "#D7422F",
                                fontSize: 28,
                                height: 28,
                                width: 28,
                                alignSelf: "center",
                            },
                        }, children: _jsxs("div", { children: [_jsx("strong", { children: "Something went wrong..." }), _jsx("div", { children: message || "An error occurred while processing your request. Please try again." })] }) })] }), _jsx("div", { className: "ms-Grid-row attachmentdiv", children: _jsx("div", { className: "ms-Grid-col ms-sm3 ms-md2 ms-lg2 savebuttonmargin", children: _jsx(PrimaryButton, { className: "bottomLeftButton", text: "Retry", type: "submit", onClick: onSubmit, styles: {
                            root: {
                                width: 100,
                                height: 40,
                                fontWeight: "bold",
                                backgroundColor: "#0F1E32",
                                borderRadius: 4,
                                opacity: 1,
                                cursor: "pointer",
                            },
                            rootHovered: {
                                backgroundColor: "#0F1E32",
                                opacity: 1,
                            },
                            rootPressed: {
                                backgroundColor: "#0F1E32",
                                opacity: 1,
                            },
                        } }) }) })] }));
};
